import { seededId, type BuildCtx, type Mutation } from '@tahi/core';

export const SPENDING_DASHBOARD_ID = 'spending';

export const SPENDING_DASHBOARD_TILES = [
  { type: 'spending.today', size: 'small' },
  { type: 'spending.week', size: 'small' },
  { type: 'spending.top-categories', size: 'tall' },
] as const;

/**
 * Spending dashboard tile rows not present locally. Ids are seededId(u, 'tile', dashboardId, type),
 * which equals v0.1c's defaultTileId(u, dashboardId, type); every insert is ifAbsent.
 */
export function buildSpendingDashboardTiles(
  userId: string,
  existingTypes: ReadonlySet<string>,
  ctx: BuildCtx,
): Mutation[] {
  return SPENDING_DASHBOARD_TILES.flatMap((t, i): Mutation[] => {
    if (existingTypes.has(t.type)) return [];
    return [
      {
        id: ctx.newId(),
        table: 'tiles',
        op: 'insert',
        rowId: seededId(userId, 'tile', SPENDING_DASHBOARD_ID, t.type),
        values: {
          dashboardId: SPENDING_DASHBOARD_ID,
          moduleId: 'spending',
          type: t.type,
          position: i + 1,
          size: t.size,
          hidden: false,
          config: {},
        },
        at: ctx.now,
        source: 'spending',
        ifAbsent: true,
      },
    ];
  });
}
